export const ErrorMessage = ({ msg }: { msg: string | undefined }) => {
  if (!msg) return null;

  return <span>Error: {msg}</span>;
};
